const infoSlide = [
    {
        image: 'bg-hamburguesa',
        title: 'Hamburguesa Kolozal'
    },
    {
        image: 'bg-tacos',
        title: 'Tacos de Camaron'
    },
    {
        image: 'bg-bebida1',
        title: 'Limonada de Vino Blanco'
    },
    {
        image: 'bg-ceviche',
        title: 'Ceviche de Chicharron'
    },
    {
        image: 'bg-crumble',
        title: 'Crumble de Frutos Rojos'
    },
    {
        image: 'bg-decoracion',
        title: 'Decoracion'
    },
    {
        image: 'bg-bebida2',
        title: 'Limonada de Vino Rosado'
    },
    {
        image: 'bg-lomo',
        title: 'Lomo'
    },
    {
        image: 'bg-elotes',
        title: 'Elotes Carnudos'
    },
    {
        image: 'bg-bebida4',
        title: 'Limonada de Vino Tinto'
    },
    {
        image: 'bg-nachos',
        title: 'Nachos'
    },
    {
        image: 'bg-bebida5',
        title: 'Sangría'
    },
    {
        image: 'bg-osobuco',
        title: 'Osobuco al Vino'
    },
    {
        image: 'bg-ginTonic',
        title: 'Gin-Tonic'
    },
    {
        image: 'bg-premio',
        title: 'Premio Mejor Hamburguesa - 2022'
    },
    {
        image: 'bg-margarita',
        title: 'Margarita de Mango'
    },
    {
        image: 'bg-piñaColada',
        title: 'Piña Colada'
    },
    {
        image: 'bg-kolozoGastrobar',
        title: 'Kolozo Gastrobar'
    },
    {
        image: 'bg-bautizo',
        title: 'Decoracion Bautizo'
    },
    {
        image: 'bg-marimondas2',
        title: 'Celebracion Carnaval'
    },
    {
        image: 'bg-almuerzo',
        title: 'Almuerzo ejecutivo'
    },
    {
        image: 'bg-amigos',
        title: 'Celebraciones'
    },
    {
        image: 'bg-cumple',
        title: 'Cumpleaños'
    },
    {
        image: 'bg-cumpleDec',
        title: 'Decoracion Cumpleaños'
    },
    {
        image: 'bg-emperador',
        title: 'Emperador Kolozo'
    }
]

export default infoSlide;